import { formalizacaoLinkRepository } from '@infra/supabase/repositories/SupabaseFormalizacaoLinkRepository';

export const getFormalizacaoLink = formalizacaoLinkRepository.getLink;
export const lookupFormalizacaoLink = formalizacaoLinkRepository.lookup;
export const submitFormalizacaoLink = formalizacaoLinkRepository.submit;
export type {
  FormalizacaoLink,
  FormalizacaoLookup,
  FormalizacaoSubmitResult,
} from '@infra/supabase/repositories/SupabaseFormalizacaoLinkRepository';
